/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Division_UnassignedInputs */

const th_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้กำหนดรุ่น`)
};

const en_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Division unassigned`)
};

const ja_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部門未割当`)
};

const zh_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未分配分区`)
};

const es_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría sin asignar`)
};

const pt_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria não definida`)
};

const id_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi belum ditetapkan`)
};

const fr_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie non attribuée`)
};

const tl_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang dibisyon`)
};

const vi_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xếp bảng`)
};

const ko_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디비전 미배정`)
};

const de_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasse nicht zugewiesen`)
};

const ru_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивизион не назначен`)
};

const tr_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grup atanmadı`)
};

const it_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria non assegnata`)
};

const pl_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie przypisano grupy`)
};

const uk_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивізіон не призначено`)
};

const hi_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्ग तय नहीं`)
};

const ar_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُحدَّد الفئة`)
};

const ms_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisyen belum ditetapkan`)
};

const bn_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিভাগ নির্ধারিত নয়`)
};

const zh_tw2_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未指派分組`)
};

const zh_hk2_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未指派組別`)
};

const ur_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درجہ مقرر نہیں`)
};

const fa_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گروه تعیین نشده`)
};

const sw_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daraja halijapangwa`)
};

const nl_division_unassigned = /** @type {(inputs: Division_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasse niet toegewezen`)
};

/**
* | output |
* | --- |
* | "Division unassigned" |
*
* @param {Division_UnassignedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const division_unassigned = /** @type {((inputs?: Division_UnassignedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Division_UnassignedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_division_unassigned(inputs)
	if (locale === "ja") return ja_division_unassigned(inputs)
	if (locale === "zh") return zh_division_unassigned(inputs)
	if (locale === "es") return es_division_unassigned(inputs)
	if (locale === "pt") return pt_division_unassigned(inputs)
	if (locale === "id") return id_division_unassigned(inputs)
	if (locale === "fr") return fr_division_unassigned(inputs)
	if (locale === "tl") return tl_division_unassigned(inputs)
	if (locale === "vi") return vi_division_unassigned(inputs)
	if (locale === "ko") return ko_division_unassigned(inputs)
	if (locale === "de") return de_division_unassigned(inputs)
	if (locale === "ru") return ru_division_unassigned(inputs)
	if (locale === "tr") return tr_division_unassigned(inputs)
	if (locale === "it") return it_division_unassigned(inputs)
	if (locale === "pl") return pl_division_unassigned(inputs)
	if (locale === "uk") return uk_division_unassigned(inputs)
	if (locale === "hi") return hi_division_unassigned(inputs)
	if (locale === "ar") return ar_division_unassigned(inputs)
	if (locale === "ms") return ms_division_unassigned(inputs)
	if (locale === "bn") return bn_division_unassigned(inputs)
	if (locale === "zh-TW") return zh_tw2_division_unassigned(inputs)
	if (locale === "zh-HK") return zh_hk2_division_unassigned(inputs)
	if (locale === "ur") return ur_division_unassigned(inputs)
	if (locale === "fa") return fa_division_unassigned(inputs)
	if (locale === "sw") return sw_division_unassigned(inputs)
	if (locale === "nl") return nl_division_unassigned(inputs)
	return en_division_unassigned(inputs)
});